<template>
    <div class="modal-step-container">
        <section class="choose-color-cont">
        <label class="form-label">Quiz Color</label>
        <formColorSelector
            :initialColor="quizColor"
            @selectedColor="getQuizColor"
        />
        </section>
        <hr>
        <section class="take-credit-cont">
            <label class="take-credit-title">Take Credit (optional)</label>
            <p class="form-desc">
                Share the quiz with your name to let everyone know how funny you are.
            </p>
            <formTxtInput v-for="(txtInput) in creditInfo"
                :key="txtInput.id"
                :inputData="txtInput"
                @txtvalue="getTxtValue($event, txtInput)"
            />
        </section>
        <hr>
        <section class="make-quiz-private-cont">
            <div class="make-private-title">
                <label for="switchMakeQuizPrivate">Make quiz private</label>
                <p class="form-desc">By default, all quizes are published on gifbanana.com</p>
            </div>
            <div class="switch-controller">
                <input type="checkbox" name="" id="switchMakeQuizPrivate" v-model="quizIsPrivate">
                <label for="switchMakeQuizPrivate"></label>
            </div>
        </section>
    </div>
</template>

<script>
import formTxtInput from './formTxtInput'
import formColorSelector from './formColorSelector'

export default {
    name: "gifCreationStep2",
    components: {
        formTxtInput,
        formColorSelector,
    },
    data() {
        return {
            title: "Quiz Options",
            subtitle: "Create Your Own Quiz",
            // quizColor: "#0F6FFF", // Default color
            quizColor: this.assignRandomColor(),
            lightCard: false,
            quizIsPrivate: false,
            creditInfo: [
                {
                    id: 1,
                    inputValue: "",
                    inputVisible: true,
                    inputID: "userFullName",
                    withLabel: true,
                    labelTxt: "Your name",
                    placeHolderTxt: "i.e. Michael Scott",
                    showCharCount: true,
                    maxCharLength: 80,
                    removeInputBtn: false,
                    autoFocus: false,
                },
                {
                    id: 2,
                    inputValue: "",
                    inputVisible: true,
                    inputID: "userEmail",
                    withLabel: true,
                    labelTxt: "Your email",
                    placeHolderTxt: "i.e. M.Scott@gifbanana.com",
                    showCharCount: true,
                    maxCharLength: 80,
                    removeInputBtn: false,
                    autoFocus: false,
                }
            ],
            stepData: {
                title: "",
                subtitle: "",
                quizColor: "",
                lightCard: null,
                quizIsPrivate: null,
                creditInfo: {
                    "name": null,
                    "email" : null,
                }
            },
        }
    },
    watch: {
        creditInfo: {
            handler() {
                this.updateEmitStepData();
            },
            deep: true,
        },
        quizIsPrivate: function() {
            this.updateEmitStepData();
        },
        quizColor: function() {
            this.updateEmitStepData();
        },
        lightCard: function() {
            this.updateEmitStepData();
        },
    },
    methods: {
        getTxtValue(val, item) {
            item.inputValue = val;
            // get text data from $event and put it in inputValue
        },
        getQuizColor(colorVal) {
            this.quizColor = colorVal;
            if (
                    colorVal == '#FDB322' ||
                    colorVal == '#FF6464' ||
                    colorVal == '#0FF0FF'
                ) {
                this.lightCard = true;
            } else {
                this.lightCard = false;
            }
        },
        assignRandomColor() {
            let colors = ['#FDB322', '#FF6464', '#933EFF', '#0F6FFF', '#0FF0FF'];
            let colorsCount = colors.length -1;
            let randomNum = Math.floor(Math.random() * colorsCount); // generate random integer between 0 & count
            
            return colors[randomNum];
        },
        emitData() {
            this.$emit('stepData', this.stepData);
        },
        updateEmitStepData() {
            this.stepData = {
                title: this.title,
                subtitle: this.subtitle,
                quizColor: this.quizColor,
                lightCard: this.lightCard,
                quizIsPrivate: this.quizIsPrivate,
                creditInfo: {
                    "name": this.creditInfo[0].inputValue,
                    "email" : this.creditInfo[1].inputValue,
                }
            }
            this.emitData();
        },
    },
    mounted() {
        this.updateEmitStepData();
        this.emitData();
    },
}
</script>

<style>

</style>